// removed by extract-text-webpack-plugin
module.exports = {"FooterNavigation":"FooterNavigation","FooterNavigation__container":"FooterNavigation__container","FooterNavigation__layout":"FooterNavigation__layout","FooterNavigation__layout-left":"FooterNavigation__layout-left","FooterNavigation__layout-right":"FooterNavigation__layout-right","FooterNavigation__list":"FooterNavigation__list","FooterNavigation__list-item":"FooterNavigation__list-item","Hyperlink":"Hyperlink","Hyperlink__text-pc":"Hyperlink__text-pc","Hyperlink__text-mb":"Hyperlink__text-mb","FooterNavigation__copyright":"FooterNavigation__copyright"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/footer-navigation/styles.css
// module id = 691
// module chunks = 0 1